import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ROUTER_NAVIGATION, RouterNavigationAction } from '@ngrx/router-store';
import { withLatestFrom, map } from 'rxjs/operators';
import * as FlowActions from './flow.actions';
import { selectCurrentContext } from './flow.selectors';

@Injectable()
export class FlowEffects {
    constructor(private actions$: Actions, private store: Store) {}

    clearOnContextChange$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ROUTER_NAVIGATION),
            withLatestFrom(this.store.select(selectCurrentContext)),
            map(([action, currentContext]: any) => {
                const url = action.payload?.routerState?.url ?? '';
                const newContext = this.extractContext(url) as string;

                // nếu chưa có context thì set
                if (!currentContext && newContext) {
                    return FlowActions.setContext({ context: newContext });
                }

                // rule preserve: từ product/detail -> back về new-product thì vẫn giữ context cũ
                if (
                    currentContext?.startsWith('products/detail') &&
                    newContext === 'products/new-product'
                ) {
                    return FlowActions.preserveContext({ context: currentContext });
                }

                // nếu khác context thì clear
                if (currentContext && newContext !== currentContext) {
                    return FlowActions.clearContext({ newContext });
                }

                return FlowActions.noop();
            })
        )
    );

    // chỉ lấy segment đầu tiên làm flow
    private extractContext(url: string): string | null {
        if (!url) return null;
        const cleanUrl = url.split('?')[0];
        const segments = cleanUrl.split('/').filter(Boolean);
        return segments.length ? segments[0] : 'root';
    }

    // so sánh flow
    private isSameFlow(ctx1: string, ctx2: string): boolean {
        return ctx1 === ctx2;
    }
}
